// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__86P5Q","modalFooterButton":"ModalNotes_modalFooterButton__DUziX"};